/**
 * Protector försäkringsimport – API-klient.
 */

import api from '@/services/api/client';

export interface ProtectorImportListItem {
  id: number;
  originalFilename: string;
  periodEndDate: string | null;
  rowCount: number;
  vehiclesUpdated: number;
  vehiclesSkipped: number;
  importedAt: string;
}

export interface ProtectorImportResult {
  filename: string;
  duplicate: boolean;
  importId?: number;
  periodEndDate?: string | null;
  rowCount?: number;
  vehiclesUpdated?: number;
  vehiclesSkipped?: number;
  skippedRegistrations?: string[];
  parseErrors?: string[];
  message?: string;
}

export interface VehicleInsuranceHistoryRow {
  periodEndDate: string;
  agreementNo: string | null;
  startDate: string | null;
  endDate: string | null;
  trafficTotal: number | null;
  delkasko: number | null;
  vagnskada: number | null;
  premiumYear: number | null;
  totalAmount: number | null;
  costMonth: number | null;
}

const base = '/api/deque/protector-insurance';

export async function listProtectorImports(): Promise<ProtectorImportListItem[]> {
  const res = await api.get<{ success: boolean; data: ProtectorImportListItem[] }>(`${base}/imports`);
  return res.data.success ? res.data.data ?? [] : [];
}

export async function uploadProtectorFiles(files: File[]): Promise<ProtectorImportResult[]> {
  const form = new FormData();
  for (const file of files) form.append('files', file);
  const res = await api.post<{ success: boolean; data: { results: ProtectorImportResult[] } }>(
    `${base}/import`,
    form,
    { headers: { 'Content-Type': 'multipart/form-data' } }
  );
  return res.data.success ? res.data.data.results ?? [] : [];
}

export async function getVehicleInsuranceHistory(
  vehicleId: number
): Promise<VehicleInsuranceHistoryRow[]> {
  const res = await api.get<{ success: boolean; data: VehicleInsuranceHistoryRow[] }>(
    `${base}/vehicles/${vehicleId}/history`
  );
  return res.data.success ? res.data.data ?? [] : [];
}
